import { render } from "./CPOCreation.vue?vue&type=template&id=36005212&scoped=true"
import script from "./CPOCreation.vue?vue&type=script&lang=js"
export * from "./CPOCreation.vue?vue&type=script&lang=js"

import "./CPOCreation.vue?vue&type=style&index=0&id=36005212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36005212"]])

export default __exports__